import React from "react";
import UpdateProject from "./UpdateProject";

const EditProject = ({
  selectedProject,
  setSelectedProject,
  handleUpdateProject,
  cancelEdit,
}) => {
  return (
    <div>
      <UpdateProject
        updatedProject={selectedProject}
        setUpdatedProject={setSelectedProject}
        handleUpdate={handleUpdateProject}
        cancelEdit={cancelEdit}
      />
    </div>
  );
};

export default EditProject;
